export const isMyDayFeatureEnabledForTenant = ({
	tenantSettings,
	isAVC,
	isDevelopment = false,
} = {}) => {
	if (isDevelopment) {
		return true;
	}

	if (isAVC) {
		return tenantSettings?.myDayEnabled !== false;
	}

	return tenantSettings?.myDayEnabled === true;
};

export const isMyDayUserSettingEnabled = user => (
	Boolean(user) &&
	user.settings?.myDayEnabled === true &&
	user.settings?.preferClassicHome !== true
);

export const isMyDayEnabledForUser = ({
	user,
	tenantSettings,
	isAVC,
	isDevelopment = false,
} = {}) => {
	if (!user || !isMyDayFeatureEnabledForTenant({ tenantSettings, isAVC, isDevelopment })) {
		return false;
	}

	// My day is an explicit per-user opt-in; preferClassicHome remains a legacy opt-out.
	return isMyDayUserSettingEnabled(user);
};
